import { DeviceHub } from '@mui/icons-material'
import { PlatformNavIcons } from './LeftNav.types'
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import dynamic from 'next/dynamic'

const Analytics = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Analytics')
)

const AutoDesign = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/AutoDesign')
)
const Book = dynamic(() => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Book'))
const BookFilled = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/BookFilled')
)
const Components = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Components')
)
const FlowcodeDark = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/FlowcodeDark')
)
const FlowpageDark = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/FlowpageDark')
)
const Folder = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Folder')
)
const Globe = dynamic(() => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Globe'))
const Hashtag = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Hashtag')
)
const Help = dynamic(() => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Help'))
const Logout = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Logout')
)
const Org = dynamic(() => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Org'))
const PaintPaletteDark = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/PaintPaletteDark')
)

const PhotoAdd = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/PhotoAdd')
)
const Profile = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Profile')
)
const ProfileOutline = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/ProfileOutline')
)
const QuestionMark = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/QuestionMark')
)
const Reports = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Reports')
)
const Rocket = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Rocket')
)
const RocketOutline = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/RocketOutline')
)
const Store = dynamic(() => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Store'))
const Templates = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Templates')
)
const Archive = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/Archive')
)
const VideoToolsSvg = dynamic(
  () => import('@dtx-company/shared-components/src/foundation/Icons/Nav/VideoOverlay/index')
)
import { FC } from 'react'

interface PlatformNavIconProps {
  color?: string
  iconId: string
  fontSize?: number
}

export const PlatformNavIcon: FC<PlatformNavIconProps> = ({ iconId, color, fontSize = 20 }) => {
  switch (iconId) {
    case PlatformNavIcons.Bundles:
      return <DeviceHub htmlColor={color} />
    case PlatformNavIcons.Forms:
      return <ListAltOutlinedIcon htmlColor={color} />
    case PlatformNavIcons.Studio:
      return <PaintPaletteDark color={color} fontSize={fontSize} />
    case PlatformNavIcons.Flowcode:
      return <FlowcodeDark color={color} fontSize={fontSize} />
    case PlatformNavIcons.Flowpage:
      return <FlowpageDark color={color} fontSize={fontSize} />
    case PlatformNavIcons.Flowtag:
      return <Hashtag color={color} fontSize={fontSize} />
    case PlatformNavIcons.Folder:
      return <Folder color={color} fontSize={fontSize} />
    case PlatformNavIcons.Store:
      return <Store color={color} fontSize={fontSize} />
    case PlatformNavIcons.Analytics:
      return <Analytics color={color} fontSize={fontSize} />
    case PlatformNavIcons.Org:
      return <Org color={color} fontSize={fontSize} />
    case PlatformNavIcons.Reports:
      return <Reports color={color} fontSize={fontSize} />
    case PlatformNavIcons.Domains:
      return <Globe color={color} fontSize={fontSize} />
    case PlatformNavIcons.Rocket:
      return <Rocket color={color} fontSize={fontSize} />
    case PlatformNavIcons.Profile:
      return <Profile color={color} fontSize={fontSize} />
    case PlatformNavIcons.Help:
      return <Help color={color} fontSize={fontSize} />
    case PlatformNavIcons.Logout:
      return <Logout color={color} fontSize={fontSize} />
    case PlatformNavIcons.HelpOutline:
      return <QuestionMark color={color} fontSize={fontSize} />
    case PlatformNavIcons.RocketOutline:
      return <RocketOutline color={color} fontSize={fontSize} />
    case PlatformNavIcons.Book:
      return <Book color={color} fontSize={fontSize} />
    case PlatformNavIcons.ProfileOutline:
      return <ProfileOutline color={color} fontSize={fontSize} />
    case PlatformNavIcons.BookFilled:
      return <BookFilled color={color} fontSize={fontSize} />
    case PlatformNavIcons.Components:
      return <Components color={color} fontSize={fontSize} />
    case PlatformNavIcons.AutoDesign:
      return <AutoDesign color={color} fontSize={fontSize} />
    case PlatformNavIcons.PhotoAdd:
      return <PhotoAdd color={color} fontSize={fontSize} />
    case PlatformNavIcons.VideoOverlay:
      return <VideoToolsSvg color={color} fontSize={fontSize} />
    case PlatformNavIcons.Templates:
      return <Templates color={color} fontSize={fontSize} />
    case PlatformNavIcons.Trash:
      return <Archive color={color} fontSize={fontSize} />
  }

  return <></>
}
